import { BadRequest, GenericError, NoDataFound, NotAuthorizeError } from "../../ErrorType";

export const getApiSettings = async () => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/apisettings`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const updateApiSettings = async (options) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/apisettings`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body: JSON.stringify(options)
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const createForm = async (payload) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/form`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body : JSON.stringify(payload)
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const updateForm = async (payload) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/form`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body : JSON.stringify(payload)
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const deleteForm = async (id) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/form?id=${id}`, {
    method: 'DELETE',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getForms = async () => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/forms`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getMatrix = async () => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/enquiry_matrix`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const importMatrix = async (file) => {

  let formData = new FormData()
  formData.append('files',file,file.name);
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/enquiry_import`, {
    method: 'POST',
    headers: { 
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body: formData
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getMenus = async () => {

  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/menu_permissions`, {
    method: 'GET',
    headers: { 
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const saveMenus = async (menu) => {

  let response = await fetch(`${window.bf_globals.apibase}/customerportal/admin/menu_permissions`, {
    method: 'POST',
    headers: { 
      'Content-Type' : 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body : JSON.stringify(menu)
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

